import React from 'react';
import { useHistory } from 'react-router-dom';
import { ArticleSimple } from '@app/utils/types';
import ButtonOutlined from '@components/ButtonOutlined';
import { resolveStrapiImgUrl } from '@app/utils';
import routes from '@routes';
import { Container, ImageBox, Content, Title } from './styles';
import { useEventSlug } from '@app/hooks/useEventSlug';
import { useTrackMarketoLinkClick } from '@app/hooks';

const ArticleSmall = ({
  groupId,
  isCarousel,
  props,
}: {
  groupId: string;
  props: { attributes: ArticleSimple };
  isCarousel?: boolean;
}) => {
  const history = useHistory();
  const eventSlug = useEventSlug();
  const trackLink = useTrackMarketoLinkClick();

  const {
    attributes: { title, image, slug, buttonText },
  } = props;

  const imgUrl = resolveStrapiImgUrl(image);

  const goToArticle = () => {
    trackLink();
    history.push(routes.EVENT.ARTICLE(groupId, slug, eventSlug));
  };

  return (
    <Container>
      <ImageBox image={imgUrl} {...(isCarousel && { onClick: goToArticle })} />
      <Content>
        <Title>{title}</Title>
        <div>
          <ButtonOutlined
            title={buttonText ? buttonText : 'Read Article'}
            onClick={goToArticle}
          />
        </div>
      </Content>
    </Container>
  );
};

export default ArticleSmall;
